import { User } from '../types/user'

export const getDisplayName = (user?: User) => {
  if (!user) return 'Inconnu'
  if (user?.displayName) return user.displayName
  return user?.email ? user.email.split('@')[0] : 'Inconnu'
}
